import { msalInstance, apiRequest } from "./msalConfig";

// Acquire API Token with MSAL
export async function acquireApiToken(account) {
    try {
        const response = await msalInstance.acquireTokenSilent({
            ...apiRequest,
            account
        });
        return response.accessToken;
    } catch (err) {
        console.warn("Silent token acquisition failed — falling back to popup");
        const response = await msalInstance.acquireTokenPopup({
            ...apiRequest,
            account
        });
        return response.accessToken;
    }
}

export function scheduleTokenRenewal(account) {
    const token = sessionStorage.getItem("jwt");
    if (!token) return;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expMs = payload.exp * 1000;
        const nowMs = Date.now();
        const fiveMinutes = 5 * 60 * 1000;
        const delay = expMs - nowMs - fiveMinutes;

        if (delay <= 0) {
            refreshToken(account); // already close to expiry
        } else {
            console.log(`Token will be renewed in ${Math.round(delay / 1000)}s`);
            setTimeout(() => refreshToken(account), delay);
        }
    } catch (e) {
        console.error("Failed to parse token", e);
    }
}

export async function refreshToken(account) {
    console.log("Refreshing API token...");
    try {
        const newToken = await acquireApiToken(account);
        sessionStorage.setItem("jwt", newToken);
        scheduleTokenRenewal(account); // schedule next one
    } catch (err) {
        console.error("Silent refresh failed:", err);
    }
}



// WEBPACK FOOTER //
// ./src/auth/token-renewal.js